// FavouriteItem Component

import PropTypes from 'prop-types'
import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd'

import FavouriteItemBase from './favourite_itembase.jsx'

const itemSource = {
  beginDrag (props) {
    const item = props.item
    item.index = props.index

    return item
  },
  endDrag (props, monitor) {
    const { index: droppedIndex, originalIndex } = monitor.getItem()
    const didDrop = monitor.didDrop()

    if (!didDrop) {
      props.onMoveItem(droppedIndex, originalIndex)
    } else {
      props.onDragEnd()
    }
  }
}

const itemTarget = {
  hover (props, monitor) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    if (dragIndex !== hoverIndex) {
      props.onMoveItem(dragIndex, hoverIndex)
      monitor.getItem().index = hoverIndex
    }
  }
}

@dropTarget((_props) => 'all', itemTarget, (connect) => ({
  connectDropTarget: connect.dropTarget()
}))
@dragSource((_props) => 'all', itemSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  dragItem: monitor.getItem(),
  isDragging: monitor.isDragging()
}))
class FavouriteItem extends FavouriteItemBase {
  static get propTypes () {
    return {
      item: PropTypes.object,
      currentUser: PropTypes.bool,
      currentUserProjects: PropTypes.array,
      showEdit: PropTypes.bool,
      index: PropTypes.number.isRequired,
      isDragging: PropTypes.bool.isRequired,
      connectDragSource: PropTypes.func,
      connectDropTarget: PropTypes.func,
      onClick: PropTypes.func,
      onDelete: PropTypes.func,
      onMoveItem: PropTypes.func,
      onDragEnd: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      item: null,
      currentUser: false,
      currentUserProjects: [],
      showEdit: false,
      index: -1,
      isDragging: false,
      connectDragSource: null,
      connectDropTarget: null,
      onClick: null,
      onDelete: null,
      onMoveItem: null,
      onDragEnd: null
    }
  }

  render () {
    return this.props.connectDragPreview(super.render())
  }
}

export default FavouriteItem
